/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage200,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage.ts";

export const getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParamsSchema =
  z.object({
    scholarshipTypeId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage200Schema =
  z.number() as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500>;

export const getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse>;
